// components/About.jsx
import React from 'react';

const Introducción = () => {
  return (
    <section id="nosotros" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          {/* Text Content */}
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Más de 40 años cultivando  <span className="text-green-600">confianza y calidad</span>
            </h2>
            
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              En Industrias Campo Fresco fabricamos una gran variedad de productos alimenticios
              de la más alta calidad
            </p>
            
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Más de 40 años de experiencia en el mercado que nos han permitido consolidarnos como una empresa sólida, confiable y comprometida con la excelencia. 
              Nuestros estándares refuerzan aún más la calidad de nuestros productos.
            </p>

            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Además de las mejores cosechas nacionales, también importamos y exportamos productos de la más alta calidad. 
              Atendemos a los diferentes canales del sector con productos y atención acorde a las necesidades específicas de cada uno: 
              Autoservicio y atendemos diferentes canales del sector como canal tradicional y moderno.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Introducción;